import Url from "@shared/services/api/utils/Url";

/**
 * Url helper
 */
export default function url(...args: Parameters<typeof Url.format>) {
  return Url.format(...args);
}
